"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordMailboxService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordMailboxService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordMailboxService.instance) {
      return CordMailboxService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordMailboxService.instance = this;
  }
  getMessage(messageId) {
    return this.get('emails/' + messageId);
  }
  createMessage(message) {
    return this.post('emails', message);
  }
  createMessageOnApplication(message, applicationId) {
    return this.post('applications/' + applicationId + '/emails', message);
  }
  sendMessage(messageId) {
    return this.post('emails/' + messageId + '/send', null);
  }
  getMessages(queryObj) {
    return this.post('graphQl/emails/search', queryObj);
  }
  deleteMessage(messageId) {
    return this.delete('emails/' + messageId);
  }
  updateMessage(messageId, message) {
    return this.patch('emails/' + messageId, message);
  }
  updateMessageDraft(messageId, message) {
    return this.put('emails/' + messageId, message);
  }
  getAttachments(messageId) {
    return this.get('emails/' + messageId + '/attachments');
  }
  getAttachment(attachmentId) {
    return this.get('attachments/' + attachmentId);
  }
  uploadAttachment(messageId, data) {
    return this.post('emails/' + messageId + '/attachments', data);
  }
  deleteAttachment(attachmentId) {
    return this.delete('attachments/' + attachmentId);
  }
}
exports.CordMailboxService = CordMailboxService;
CordMailboxService.instance = null;
